import React, { useEffect, useState } from 'react';
import { Box } from 'native-base';
import {
    CustomIcon,
    NavigationItem,
    resizedUrl,
    useSpringBigStore,
    useTheme,
} from '@springbig/shared';
import Pressable from './Pressable';
import { Caption } from './Typography';
import { AppRouteProps, useAppNavigate } from '~/pages';
import { generatePath } from '~/utils/url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser,
    faAward,
    faHome,
    faDollarSign,
    faComment,
    faTrophy,
    faCartShopping,
    faShareAlt,
    faGifts,
    faGem,
    faLink
} from '@fortawesome/free-solid-svg-icons';
import Image from '~/shared/Image';
import { useParams } from 'react-router';

const BottomNavigation = () => {

    const [links, setLinks] = useState<Array<NavigationItem>>([]);
    const { member, walletId, merchant } = useSpringBigStore();
    const params = useParams();
    const { navigate, location } = useAppNavigate();

    const {
        nav_background,
        nav_icon,
        nav_icon_active,
        footer_length,
        custom_icons,
        navigation,
        is_footer_text,
    } = useTheme();

    const currentPath = location.pathname;

    useEffect(
        () => {

            if (member) {

                const conditions = {
                    Subscriptions: member.subscriptions_enabled,
                    SpringbigPay: member.gift_card_enabled,
                    Milestones: member.show_milestones,
                    Rewards: member.show_rewards,
                    Cart: member.merchant_website?.length > 0,
                    Refer: member.referrals?.active,
                    Shop: merchant?.dutchie_plus_enabled,
                };

                let _items = navigation.filter(item => conditions[item.toScreen] !== false);

                _items = _items.filter(
                    (item) =>
                        item.index < footer_length &&
                        item?.toScreen?.toString() !== "LocationStore",
                );

                setLinks(_items);
            }
        },
        [member]
    );

    const handleNavigation = (path: string) => {

        const id = walletId || params.wallet_id;
        const _path = generatePath(path, id) as AppRouteProps;
        navigate(_path as AppRouteProps);
    };

    const handleColor = (path: string) => {

        if (currentPath?.split('/')[3] === path?.split('/')[2]) {
            return nav_icon_active;
        }

        return nav_icon;
    };

    return (
        <Box
            zIndex={999}
            w={'100%'}
            bg={'transparent'}
            height={'60px'}
            display={'flex'}
            flexDirection={'row'}
        >
            { links?.map((link, i) => {

                const customIcons = custom_icons?.find(icon => {

                    return icon?.toScreen === link?.toScreen || icon?.toScreen === link?.path;
                });

                return (
                    <Pressable
                        justifyContent={'center'}
                        alignItems={'center'}
                        flex={1}
                        bg={nav_background}
                        key={i}
                        onPress={() => {

                            if (link.toScreen === 'Cart') {
                                window.open(member.merchant_website, '_blank');
                            }
                            else if (link.toUrl) {
                                window.open(link.toUrl, '_blank');
                            }
                            else {
                                handleNavigation(link.path);
                            }
                        }}
                    >
                        <BottomNavIcon
                            navInfo={link}
                            customIcons={customIcons}
                            color={handleColor(link.path)}
                            isActive={currentPath?.split('/')[3] === link.path?.split('/')[2]}
                        />
                        { is_footer_text &&
                            <Caption fontSize={10} color={handleColor(link.path)} textAlign={'center'}>
                                { link?.customLabel || link?.toScreen }
                            </Caption>
                        }
                    </Pressable>
                );
            })}
        </Box>
    );
};

const BottomNavIcon = ({
    customIcons,
    navInfo,
    color,
    isActive
}: {
    customIcons: CustomIcon,
    navInfo: NavigationItem,
    color: string,
    isActive: boolean
}) => {

    const size = '24px';

    if (customIcons && customIcons.on.url && customIcons.off.url) {
        return (
            <Image
                uri={isActive ? resizedUrl(customIcons.on.url, 24, 24) : resizedUrl(customIcons.off.url, 24, 24)}
                width={'100%'}
                h={size}
                w={size}
            />
        );
    }
    else if (navInfo) {

        const appIcons = {
            rewards: faAward,
            home: faHome,
            offers: faGifts,
            profile: faUser,
            springbigpay: faDollarSign,
            messages: faComment,
            cart: faCartShopping,
            refer: faShareAlt,
            milestones: faTrophy,
            subscriptions: faGem,
        };

        const icon = appIcons[navInfo.toScreen?.toLowerCase()];

        return (
            <Box
                h={size}
                w={size}
            >
                <FontAwesomeIcon
                    icon={icon ? icon : navInfo.toUrl ? faLink : ''}
                    color={color}
                    size={'lg'}
                    style={{
                        width: `${size} !important`,
                        height: `${size} !important`,
                        margin: 'auto'
                    }}
                />
            </Box>
        );
    }

    return null;
};

export default BottomNavigation;
